import KunLoading4 from './src/index'

KunLoading4.install = function (Vue){
	Vue.component(KunLoading4.name, KunLoading4);
}

export default KunLoading4;
